module.exports = __webpack_public_path__ + "static/media/icon-euro-search.ff611515.svg";